import _ from "lodash";
import React, { useRef } from "react";
import classes from "./StepContainer.scss";

import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

import I18nHOC from "UIComponents/I18nHOC";
import UnitSelection from "AppComponents/UnitSelection";
import UnitFromGradeSelection from "AppComponents/UnitFromGradeSelection";
import PlannerResourceSelection from "AppComponents/PlannerRourcesSelection";
import LeFeed from "AppComponents/LeFeed";
import GradeOrCourseSelection from "AppComponents/GradeOrCourseSelection";
import Worksheet from "Worksheet";
import CourseSelection from "AppComponents/CourseSelection";
import CompactLEPreview from "AppComponents/CompactLEPreview";
import LearningCourseSelection from "AppComponents/LearningCourseSelection";
import { AssessmentDetailsComponent } from "Assessments";
import DiscussionStep from "../DiscussionStep";
import { colors, fontStyle } from "Constants";
import { MODE_TEACHER_CREATE } from "Worksheet/modules/WorksheetConstants";
import { setCurriculumProgram } from "ClassRoom/modules/ClassRoomModule";
import { isSchoolLibraryRoute } from "SchoolLibrary/modules/Utils";
import { setCurrentCurriculumProgram } from "Platform/modules/PlatformModule";
import { EmptyState } from "@toddle-edu/ds-web";
import { LEIllustraton, fontStyles } from "@toddle-edu/ds-theme";

import {
  AI_TUTOR_CREATION,
  CURRICULUM_TYPE_DP,
  SUBJECT_TYPE_GENERIC,
  SUBJECT_TYPE_OTHERS,
  SUBJECT_TYPE_TOK,
  SUBJECT_TYPE_LD,
  SUBJECT_TYPE_PPS,
  ASSESSMENT_TYPE_QUICK_TASK,
  ASSIGNMENT_TYPE_QUICK_TASK,
} from "Constants/stringConstants";

import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { getCurrentAcademicYear } from "modules/CommonSelectors";

const conStyle = {
  LE_SELECTION: {
    overflowY: "hidden",
  },
  COMMUNITY_LE_SELECTION: {
    overflowY: "hidden",
  },
  LE_LIBRARY_LE_SELECTION: {
    overflowY: "hidden",
  },
  TODDLE_LIBRARY_LE_SELECTION: {
    overflowY: "hidden",
  },
  TODDLE_LIBRARY_WORKSHEET_SELECTION: {
    overflowY: "hidden",
  },
  ASSESSMENT_DETAILS: {
    overflowY: "hidden",
  },
  QUESTION_CREATION: {
    overflowY: "hidden",
  },
};

const innerConStyle = {
  UNIT_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  UNIT_SELECTION_REVAMP: {
    padding: "40px 0",
    maxWidth: "1008px",
  },
  LE_CREATE_UNIT_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  LE_CREATE_UNIT_SELECTION_REVAMP: {
    padding: "40px 0",
    maxWidth: "1008px",
  },
  SMT_CREATE_UNIT_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  SMT_CREATE_UNIT_SELECTION_REVAMP: {
    padding: "40px 0",
    maxWidth: "1008px",
  },
  FMT_CREATE_UNIT_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  FMT_CREATE_UNIT_SELECTION_REVAMP: {
    padding: "40px 0",
    maxWidth: "1008px",
  },
  ASSESSMENT_CREATE_UNIT_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  ASSESSMENT_CREATE_UNIT_SELECTION_REVAMP: {
    padding: "40px 0",
    maxWidth: "1008px",
  },
  LE_SELECTION: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  COMMUNITY_LE_SELECTION: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  LE_LIBRARY_LE_SELECTION: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  TODDLE_LIBRARY_LE_SELECTION: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  TODDLE_LIBRARY_WORKSHEET_SELECTION: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  RESOURCE_SELECTION: {
    padding: "40px 64px",
    maxWidth: "1112px",
  },
  DISCUSSION_CREATION: {
    padding: "40px 64px",
    maxWidth: "728px",
  },
  SETTINGS: {
    padding: "40px 64px",
    maxWidth: "728px",
  },
  SETTINGS_REVAMP: {
    padding: "0",
    maxWidth: "1008px",
  },
  CLASS_SELECTION: {
    padding: "20px 0 0",
  },
  CLASS_SELECTION_REVAMP: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  ASSESSMENT_DETAILS: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  QT_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  WORKSHEET_QUESTION_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  QUESTION_CREATION: {
    margin: 0,
    padding: 0,
    width: "100%",
    height: "100%",
    maxWidth: "unset",
  },
  LE_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  AI_TUTOR_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  SMT_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  FMT_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  ASSESSMENT_CREATION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
  SELECT_POST: {
    padding: 0,
    margin: 0,
    maxWidth: "unset",
    height: "unset",
  },
  UNIT_FROM_GRADE_SELECTION: {
    padding: "40px 64px",
    maxWidth: "792px",
  },
  LEARNING_COURSE_SELECTION: {
    padding: 0,
    margin: 0,
    width: "100%",
    minWidth: "100%",
    height: "100%",
  },
};

const unitSelectionStepStyles = {
  itemFeedContainer: {
    gridTemplateColumns: "repeat(auto-fill, 320px)",
  },
  helperTextStyle: {
    fontWeight: "normal",
    fontSize: "1.4rem",
    fontFamily: fontStyle.regular.fontFamily,
    marginTop: "-16px",
    marginBottom: "8px",
  },
};

const profileImageProps = {
  size: "x-small",
  className: classes.profileImageContainerClass,
};

const styles = {
  feedInnerContainerStyle: {
    width: "100%",
    margin: "0 auto",
  },
  headerContainerStyle: {
    padding: "32px 32px 20px",
    width: "100%",
    margin: "0 auto",
  },
  feedContainerStyle: {
    alignItems: "center",
    padding: "0 20px 0 32px",
  },
  customNonSelectedContainerStyle: {
    borderRadius: "8px",
  },
  customSelectedContainerStyle: {
    borderRadius: "8px",
  },
  moreFiltersBarStyle: {
    marginTop: "12px",
  },
  titleTextStyle: {
    margin: 0,
    flexShrink: 0,
  },
  imageContainerStyle: {
    height: "72px",
    width: "72px",
    minWidth: "72px",
  },
  feedItemTitleStyle: {
    fontSize: "1.6rem",
    ...fontStyles.demiBold,
    marginBottom: 0,
  },
  staffDetailsStyle: {
    marginTop: "12px",
  },
  staffNameStyle: {
    ...fontStyles.medium,
    fontSize: "1.2rem",
  },
  feedDataListContainerStyle: {
    height: "100px",
  },
  headerTabContainerStyle: {
    marginBottom: 0,
  },
  customSearchBarStyle: {
    display: "flex",
    maxWidth: "320px",
    gap: "24px",
    alignItems: "center",
  },
  leFeedStyles: {
    feedInnerContainerStyle: {
      width: "100%",
    },
    headerContainerStyle: {
      padding: "40px 56px 0",
      width: "100%",
    },
    feedContainerStyle: {
      alignItems: "center",
      padding: "0 56px",
    },
    customNonSelectedContainerStyle: {
      borderRadius: "8px",
    },
    customSelectedContainerStyle: {
      borderRadius: "8px",
    },
    feedDataListContainerStyle: {
      height: "80px",
    },
    imageContainerStyle: {
      width: "48px",
      height: "48px",
      borderRadius: "8px",
    },
    feedItemTitleStyle: {
      color: colors.textDefault,
      fontFamily: "Avenir Next",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "24px",
    },
  },
  searchInputStyle: {
    maxWidth: "280px",
  },
};

const gradeSelectionStyles = {
  list: {
    gridTemplateColumns: "repeat(3, 320px)",
    justifyContent: "center",
  },
};

// in DP, not all subject types have unit planning enabled
const DP_SUBJECT_TYPES_WITH_UNIT_PLAN = [
  SUBJECT_TYPE_GENERIC,
  SUBJECT_TYPE_OTHERS,
  SUBJECT_TYPE_TOK,
  SUBJECT_TYPE_LD,
  SUBJECT_TYPE_PPS,
];

const getHelperLabel = ({ currentStep, t }) => {
  switch (currentStep) {
    case "LE_CREATE_UNIT_SELECTION":
      return t("classRoom:created_assessment_unit_part", {
        label: t("common:le_label"),
      });
    case "SMT_CREATE_UNIT_SELECTION":
      return t("classRoom:created_assessment_unit_part", {
        label: t("common:summative_assessment"),
      });
    case "FMT_CREATE_UNIT_SELECTION":
      return t("classRoom:created_assessment_unit_part", {
        label: t("common:formative_assessment"),
      });
    case "ASSESSMENT_CREATE_UNIT_SELECTION":
      return t("classRoom:created_assessment_unit_part", {
        label: t("common:assessment"),
      });
    case "WORKSHEET_UNIT_SELECTION":
      return t("classRoom:created_assessment_unit_part", {
        label: t("common:worksheet"),
      });
    default:
      return "";
  }
};

const getInnerConStyles = ({
  currentStep,
  isResourceSelection,
  isToddleLibrary,
  isSchoolLibrary,
}) => {
  const currentStepRevamp = `${currentStep}_REVAMP`;

  const isClassSelectionStep = currentStep == "CLASS_SELECTION";

  const shouldUseRevampStyles =
    innerConStyle[currentStepRevamp] &&
    !isResourceSelection &&
    (isClassSelectionStep ? isToddleLibrary || isSchoolLibrary : true);

  if (shouldUseRevampStyles) {
    return innerConStyle[currentStepRevamp];
  } else {
    return innerConStyle[currentStep];
  }
};

const StepItem = React.memo(props => {
  const {
    currentStep,
    selectedState,
    changeSelectedState,
    mode,
    courseId,
    getDiscussionPromptRef,
    setAssessmentDetailsRef,
    setWorksheetRef,
    setUploadingStatus,
    t,
    updateCourseId,
    setCurriculumProgram,
    portalType,
    courseList,
    curriculumType,
    assignmentId,
    creationMode,
    updateUnitPlanDataInRedux,
    handleScroll,
    courseSubjects,
    grades,
    creationSource,
    pageName,
    isFromUnitPlan,
    setDialogBoxParams,
    onWorksheetDoneClick,
    isToddleLibrary,
    isSchoolLibrary,
    updateSelectedItems,
    defaultQuestionIds,
    setCurrentClonedImportedLeId,
    toddleLibraryGlobalGradeUID,
    showWorksheetAssistant,
    isDraft,
    courseSubjectType,
    setCurrentCurriculumProgram,
    currentAcademicYearId,
    testId,
    setIsAssessmentFetched,
    learningCourseId,
    primaryGradeId,
    handleIsGeneratingAIResponse,
    onCommentActiveChange,
    onCommentCountsChange,
  } = props;

  let stepPortalType;

  const updateSelectedCourseAndCurriculum = ({
    gradeId,
    courseId: selectedCourseId,
    curriculumProgram,
    course,
  }) => {
    if (isToddleLibrary && getIsLearningCoursesEnabled()) {
      updateSelectedItems({
        learningCourseSelectionState: {
          selectedLearningCourse: { id: selectedCourseId },
        },
      });
    } else {
      updateCourseId(selectedCourseId || gradeId);
    }

    setCurriculumProgram(curriculumProgram);
    setCurrentCurriculumProgram(curriculumProgram);

    if (!_.isEmpty(course)) {
      changeSelectedState(prev => {
        return {
          ...prev,
          selectedCourse: course,
        };
      });
    }
    if (isToddleLibrary && !_.isEqual(selectedCourseId, courseId)) {
      setCurrentClonedImportedLeId("");
    }
  };

  switch (currentStep) {
    case "UNIT_SELECTION":
    case "LE_CREATE_UNIT_SELECTION":
    case "WORKSHEET_UNIT_SELECTION":
    case "SMT_CREATE_UNIT_SELECTION":
    case "FMT_CREATE_UNIT_SELECTION":
    case "ASSESSMENT_CREATE_UNIT_SELECTION":
      return (
        <UnitSelection
          updateSelectedItems={(id, templateId) => {
            changeSelectedState(prev => {
              return {
                ...prev,
                unitPlanId: id,
                unitPlanTemplateId: templateId,
                importedLeId: "",
              };
            });
          }}
          handleScroll={handleScroll}
          isQueryPaginated={true}
          helperLabel={getHelperLabel({ currentStep, t })}
          styles={unitSelectionStepStyles}
          cardDimensions={{ width: 320, height: 280 }}
          selectedItems={selectedState.unitPlanId}
          isSearchEnabled={true}
          showFilters={true}
          filtersToShow={["theme", "unitType", "grade", "subject", "creator"]}
          shouldTruncateFilterLabels={true}
          customSearchBarStyle={styles.searchInputStyle}
          courseId={courseId}
          showAlert={true}
          testId={testId}
        />
      );

    case "RESOURCE_SELECTION":
      return (
        <PlannerResourceSelection
          parentId={selectedState.unitPlanId}
          parentType={"UNIT_PLAN"}
          updateSelectedItems={attachments => {
            changeSelectedState(prev => {
              return {
                ...prev,
                resource: { ...prev.resource, attachments },
              };
            });
          }}
          selectedItems={selectedState.resource.attachments}
        />
      );
    case "DISCUSSION_CREATION":
      return (
        <DiscussionStep
          canAddAttachment={selectedState.creationMode != "IMPORT_RESOURCES"}
          resource={selectedState.resource}
          contentType={selectedState.contentType}
          getDiscussionPromptRef={getDiscussionPromptRef}
          updateSelectedItems={param => {
            changeSelectedState(prev => {
              const { isStudentSubmissionEnabled, ...rest } = param;
              return {
                ...prev,
                isStudentSubmissionEnabled:
                  isStudentSubmissionEnabled || prev.isStudentSubmissionEnabled,
                resource: { ...prev.resource, ...rest },
              };
            });
          }}
          setUploadingStatus={setUploadingStatus}
        ></DiscussionStep>
      );
    case "CLASS_SELECTION": {
      const courseSelectionComponent =
        isToddleLibrary || isSchoolLibrary ? (
          <CourseSelection
            selectedIds={
              isToddleLibrary && getIsLearningCoursesEnabled()
                ? [learningCourseId]
                : [courseId]
            }
            handleSelect={updateSelectedCourseAndCurriculum}
            selectedGlobalGradeUid={toddleLibraryGlobalGradeUID}
            shouldCheckIfTermsExist={true}
            isCurriculumSelectionEnabled={!isSchoolLibrary}
            shouldDisplaySubjects={isSchoolLibrary}
            courseSubjectType={courseSubjectType}
            academicYears={
              isToddleLibrary ? _.compact([currentAcademicYearId]) : []
            }
            shouldSetPlatformCurriculumOnMount={!isToddleLibrary}
          />
        ) : (
          <GradeOrCourseSelection
            styles={gradeSelectionStyles}
            handleSelect={updateSelectedCourseAndCurriculum}
            portalType={portalType}
            groupClasses={true}
            selectedIds={[courseId]}
            showSelectedIcon={true}
            creationMode={creationMode}
          />
        );
      return courseSelectionComponent;
    }
    case "ASSESSMENT_DETAILS":
      return (
        <AssessmentDetailsComponent
          assessmentId={selectedState.leId}
          mode={"edit"}
          assessmentMode={mode}
          renderAsComponent={true}
          portalType={portalType}
          sourceFrom={creationSource}
          unitPlanId={selectedState.unitPlanId}
          updateUnitPlanDataInRedux={updateUnitPlanDataInRedux}
          assignmentId={assignmentId}
          selectedState={selectedState}
          updateSelectedItems={updateSelectedItems}
          courseSubjects={courseSubjects}
          selectedCourseId={courseId}
          setAssessmentDetailsRef={setAssessmentDetailsRef}
          creationMode={creationMode}
          isFromUnitPlan={isFromUnitPlan}
          currentStep={currentStep}
          isDraft={isDraft}
          courseGrades={grades}
          onWorksheetDoneClick={onWorksheetDoneClick}
          defaultQuestionIds={defaultQuestionIds}
          selectedCourse={_.get(selectedState, "selectedCourse", {})}
          testId={testId}
          skipAddAssignmentRender={true}
          setIsAssessmentFetched={setIsAssessmentFetched}
          learningCourseId={learningCourseId}
          primaryGradeId={primaryGradeId}
          onCommentActiveChange={onCommentActiveChange}
          onCommentCountsChange={onCommentCountsChange}
        />
      );
    case "QT_CREATION":
    case "WORKSHEET_QUESTION_CREATION":
    case "LE_CREATION":
    case "SMT_CREATION":
    case "FMT_CREATION":
    case "ASSESSMENT_CREATION":
    case AI_TUTOR_CREATION:
      return (
        <AssessmentDetailsComponent
          assessmentId={selectedState.leId}
          mode={"edit"}
          assessmentMode={mode}
          renderAsComponent={true}
          portalType={portalType}
          sourceFrom={creationSource}
          assignmentId={assignmentId}
          selectedState={selectedState}
          updateSelectedItems={updateSelectedItems}
          courseSubjects={courseSubjects}
          selectedCourseId={courseId}
          setAssessmentDetailsRef={setAssessmentDetailsRef}
          setWorksheetRef={setWorksheetRef}
          creationMode={creationMode}
          isFromUnitPlan={isFromUnitPlan}
          currentStep={currentStep}
          isDraft={isDraft}
          courseGrades={grades}
          onWorksheetDoneClick={onWorksheetDoneClick}
          defaultQuestionIds={defaultQuestionIds}
          selectedCourse={_.get(selectedState, "selectedCourse", {})}
          skipAddAssignmentRender={true}
          setIsAssessmentFetched={setIsAssessmentFetched}
          learningCourseId={learningCourseId}
          primaryGradeId={primaryGradeId}
          handleIsGeneratingAIResponse={handleIsGeneratingAIResponse}
          onCommentActiveChange={onCommentActiveChange}
          onCommentCountsChange={onCommentCountsChange}
        />
      );
    case "UNIT_FROM_GRADE_SELECTION":
      return (
        <UnitFromGradeSelection
          courseList={courseList}
          updateSelectedItems={(id, templateId) => {
            changeSelectedState(prev => {
              return {
                ...prev,
                unitPlanId: id,
                unitPlanTemplateId: templateId,
                importedLeId: "",
              };
            });
          }}
          onCourseSelect={({ course }) => {
            changeSelectedState(prev => {
              return {
                ...prev,
                selectedCourse: course,
                unitPlanId: "",
                unitPlanTemplateId: "",
              };
            });
          }}
          unitSelectionStepStyles={unitSelectionStepStyles}
          cardDimensions={{ width: 320, height: 280 }}
          selectedItems={selectedState.unitPlanId}
          selectedCourse={_.get(selectedState, "selectedCourse.courseId", "")}
          pageName={pageName}
          creationMode={creationMode}
          setDialogBoxParams={setDialogBoxParams}
          testId={testId}
        />
      );
    case "LEARNING_COURSE_SELECTION": {
      const updateLearningCourseState = property => value => {
        changeSelectedState(prev => ({
          ...prev,
          learningCourseSelectionState: {
            ...(prev.learningCourseSelectionState || {}),
            [property]: value,
          },
        }));
      };

      const learningCourseSelectionState =
        selectedState?.learningCourseSelectionState || {};

      const {
        selectedLearningCourse,
        courseSearchText = "",
        academicYear = [currentAcademicYearId],
        courseType = [],
        grade = [],
        subject = [],
      } = learningCourseSelectionState;

      return (
        <LearningCourseSelection
          selectedLearningCourse={selectedLearningCourse}
          academicYear={academicYear}
          courseType={courseType}
          grade={grade}
          subject={subject}
          setSelectedLearningCourse={updateLearningCourseState(
            "selectedLearningCourse"
          )}
          setCourseSearchText={updateLearningCourseState("courseSearchText")}
          courseSearchText={courseSearchText}
          setAcademicYear={updateLearningCourseState("academicYear")}
          setCourseType={updateLearningCourseState("courseType")}
          setGrade={updateLearningCourseState("grade")}
          setSubject={updateLearningCourseState("subject")}
        />
      );
    }
    case "SELECT_POST":
    case "LE_SELECTION":
    case "COMMUNITY_LE_SELECTION":
    case "LE_LIBRARY_LE_SELECTION":
      stepPortalType =
        currentStep == "COMMUNITY_LE_SELECTION"
          ? "COMMUNITY"
          : currentStep == "LE_LIBRARY_LE_SELECTION"
          ? "PLANNER"
          : portalType;

      return (
        <div className={classes.subInnerCon}>
          <div className={classes.stepPane}>
            <LeFeed
              courseId={courseId}
              courseList={courseList}
              unitPlanId={selectedState.unitPlanId}
              portalType={stepPortalType}
              assessmentId={selectedState.importedLeId}
              feedAsPosts={
                !_.includes(
                  ["COMMUNITY_LE_SELECTION", "LE_LIBRARY_LE_SELECTION"],
                  currentStep
                )
              }
              showHeaderText={false}
              curriculumType={curriculumType}
              importFromLeLibrary={currentStep == "LE_LIBRARY_LE_SELECTION"}
              setAssessmentId={importedLeId => {
                changeSelectedState(prev => {
                  return {
                    ...prev,
                    importedLeId,
                  };
                });
              }}
              feedInnerContainerStyle={styles.feedInnerContainerStyle}
              headerContainerStyle={styles.headerContainerStyle}
              feedContainerStyle={styles.feedContainerStyle}
              customSelectedContainerStyle={styles.customSelectedContainerStyle}
              testId={testId}
              customNonSelectedContainerStyle={
                styles.customNonSelectedContainerStyle
              }
              moreFiltersBarStyle={styles.moreFiltersBarStyle}
              titleTextStyle={styles.titleTextStyle}
              imageContainerStyle={styles.imageContainerStyle}
              feedItemTitleStyle={styles.feedItemTitleStyle}
              staffDetailsStyle={styles.staffDetailsStyle}
              staffNameStyle={styles.staffNameStyle}
              feedDataListContainerStyle={styles.feedDataListContainerStyle}
              headerTabContainerStyle={styles.headerTabContainerStyle}
              customSearchBarStyle={styles.customSearchBarStyle}
              displayCountHeadingWithSearch={true}
              profileImageContainerProps={profileImageProps}
            />
          </div>
          <div className={classes.stepPanePreviewNewWidth}>
            {!_.isEmpty(selectedState.importedLeId) ? (
              <CompactLEPreview
                assessmentId={selectedState.importedLeId}
                portalType={stepPortalType}
                showAttachmentItemV3={true}
                showFullScreenButton={false}
                attachmentItemHeight={100}
                isFullScreenLE={false}
                showEmptyState={true}
                showPostSettings={false}
                showAssignmentActionsButton={false}
                courseId={courseId}
                showCreatedBy={true}
                currentStep={currentStep}
              />
            ) : (
              <EmptyState
                subtitle={t("common:select_post_to_preview")}
                illustration={LEIllustraton}
              />
            )}
          </div>
        </div>
      );
    case "QUESTION_CREATION":
      return (
        <Worksheet
          mode={MODE_TEACHER_CREATE}
          parentId={selectedState.leId}
          parentType={"ASSESSMENT"}
          setAssessmentDetailsRef={setAssessmentDetailsRef}
          setWorksheetRef={setWorksheetRef}
          courseGrades={grades}
          onWorksheetDoneClick={onWorksheetDoneClick}
          courseSubjects={courseSubjects}
          defaultQuestionIds={defaultQuestionIds}
          portalType={"PLANNER"}
          showWorksheetAssistant={showWorksheetAssistant}
        />
      );
    default:
      return null;
  }
});

StepItem.displayName = StepItem;

const Header = React.memo(props => {
  const { heading, subHeading } = props;
  return (
    <div className={classes.header}>
      <div className={classes.heading}>{heading}</div>
      <div className={classes.subHeading}>{subHeading}</div>
    </div>
  );
});

Header.displayName = Header;

const StepContainer = React.memo(props => {
  const {
    t,
    curriculumProgram,
    currentStep,
    currentStepObj,
    changeSelectedState,
    updateSelectedItems,
    mode,
    selectedState,
    courseId,
    resourceSelection,
    getDiscussionPromptRef,
    setUploadingStatus,
    setAssessmentDetailsRef,
    setWorksheetRef,
    updateCourseId,
    setCurriculumProgram,
    portalType,
    selectedTimeSlot,
    courseList,
    curriculumType,
    assignmentId,
    creationMode,
    updateUnitPlanDataInRedux,
    grades,
    subjects,
    courseSubjects,
    creationSource,
    pageName,
    isFromUnitPlan,
    setDialogBoxParams,
    onWorksheetDoneClick,
    isToddleLibrary,
    isSchoolLibrary,
    defaultQuestionIds,
    setCurrentClonedImportedLeId,
    toddleLibraryGlobalGradeUID,
    showWorksheetAssistant,
    isDraft,
    courseSubjectType,
    currentAcademicYearId,
    setCurrentCurriculumProgram,
    testId,
    setIsAssessmentFetched,
    learningCourseId,
    primaryGradeId,
    handleIsGeneratingAIResponse,
    onCommentActiveChange,
    onCommentCountsChange,
  } = props;

  const handleScroll = useRef(null);

  const innerConStyles = getInnerConStyles({
    currentStep,
    isResourceSelection: resourceSelection,
    isToddleLibrary,
    isSchoolLibrary,
  });

  return (
    <div
      className={classes.container}
      onScroll={e => handleScroll?.current?.(e)}
      style={conStyle[currentStep]}
    >
      <div className={classes.innerContainer} style={innerConStyles}>
        {resourceSelection && <Header {...currentStepObj}></Header>}
        <StepItem
          mode={mode}
          courseList={courseList}
          curriculumProgram={curriculumProgram}
          currentStep={currentStep}
          selectedState={selectedState}
          changeSelectedState={changeSelectedState}
          updateSelectedItems={updateSelectedItems}
          courseId={courseId}
          getDiscussionPromptRef={getDiscussionPromptRef}
          setUploadingStatus={setUploadingStatus}
          setAssessmentDetailsRef={setAssessmentDetailsRef}
          setWorksheetRef={setWorksheetRef}
          t={t}
          handleScroll={handleScroll}
          updateCourseId={updateCourseId}
          setCurriculumProgram={setCurriculumProgram}
          portalType={portalType}
          selectedTimeSlot={selectedTimeSlot}
          curriculumType={curriculumType}
          assignmentId={assignmentId}
          creationMode={creationMode}
          updateUnitPlanDataInRedux={updateUnitPlanDataInRedux}
          grades={grades}
          subjects={subjects}
          courseSubjects={courseSubjects}
          creationSource={creationSource}
          pageName={pageName}
          isFromUnitPlan={isFromUnitPlan}
          setDialogBoxParams={setDialogBoxParams}
          onWorksheetDoneClick={onWorksheetDoneClick}
          isToddleLibrary={isToddleLibrary}
          isSchoolLibrary={isSchoolLibrary}
          defaultQuestionIds={defaultQuestionIds}
          setCurrentClonedImportedLeId={setCurrentClonedImportedLeId}
          toddleLibraryGlobalGradeUID={toddleLibraryGlobalGradeUID}
          showWorksheetAssistant={showWorksheetAssistant}
          isDraft={isDraft}
          courseSubjectType={courseSubjectType}
          currentAcademicYearId={currentAcademicYearId}
          setCurrentCurriculumProgram={setCurrentCurriculumProgram}
          testId={testId}
          setIsAssessmentFetched={setIsAssessmentFetched}
          learningCourseId={learningCourseId}
          primaryGradeId={primaryGradeId}
          handleIsGeneratingAIResponse={handleIsGeneratingAIResponse}
          onCommentActiveChange={onCommentActiveChange}
          onCommentCountsChange={onCommentCountsChange}
        ></StepItem>
      </div>
    </div>
  );
});

StepContainer.displayName = "StepContainer";

const mapStateToProps = (state, ownProps) => {
  const { courseSubjects, selectedState, assessmentType } = ownProps;

  const userInfo = getUserInfo({ portalType: "PLANNER" });
  const organizationId = userInfo.org_id;

  const currentAcademicYear = getCurrentAcademicYear({ organizationId });
  const currentAcademicYearId = _.get(currentAcademicYear, "id");

  const selectedCourses = _.get(selectedState, "courses", []);
  const isToddleLibrary = state.login.activeTab == "TODDLE_LIBRARY";
  const isSchoolLibrary = isSchoolLibraryRoute();

  const { toddleLibrary: { globalFilter = {} } = {} } = state;

  const toddleLibraryGlobalGradeUID = _.get(
    globalFilter,
    "grade.mappedOrganizationEntities[0].globalGrade.uid"
  );

  let _courseSubjects = [];
  if (!_.isEmpty(courseSubjects)) {
    _courseSubjects = courseSubjects;
  } else if (_.size(selectedCourses) === 1) {
    _courseSubjects = _.get(_.first(selectedCourses), "subjects", []);
  }

  const curriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );

  let courseSubjectType = [];

  // for course selection step:
  // course should have unit planning enabled to create assessments other than quick tasks
  // so we need to restrict import in such courses as well
  if (
    (isToddleLibrary || isSchoolLibrary) &&
    curriculumType === CURRICULUM_TYPE_DP &&
    !_.includes(
      [ASSESSMENT_TYPE_QUICK_TASK, ASSIGNMENT_TYPE_QUICK_TASK],
      assessmentType
    )
  ) {
    courseSubjectType = DP_SUBJECT_TYPES_WITH_UNIT_PLAN;
  }

  return {
    curriculumType,
    courseSubjects: _courseSubjects,
    isToddleLibrary,
    isSchoolLibrary,
    toddleLibraryGlobalGradeUID,
    courseSubjectType,
    currentAcademicYearId,
  };
};

const mapActionCreators = { setCurriculumProgram, setCurrentCurriculumProgram };

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators)
)(StepContainer);
